module.exports = __webpack_public_path__ + "static/media/34DSS5.c1714f69.jpg";